import { ReactNode } from 'react'
import { AuthContext } from '../application/AuthContext'
import { useAuthStatus } from '../application/useAuthStatus'

interface Props {
  children: ReactNode
}

export function AuthProvider({ children }: Props) {
  const { authStatus, setAuthState, loading } = useAuthStatus()

  const contextValue = {
    authStatus,
    loading,
    setAuthState,
  }

  return (
    <AuthContext.Provider value={contextValue}>
      {loading || authStatus === 'loading' ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '18px',
          }}
        >
          Loading...
        </div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  )
}
